import SaleRepository from "../repository/Sales.repository";

export default class Sale {
  static async CorteCaja(date) {
    return new Promise((resolve, reject) => {
      SaleRepository.corteCaja(date)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static async Snapshot(date) {
    return new Promise((resolve, reject) => {
      SaleRepository.snapshot(date)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
